// Card-product "Stone Colour" quick view — self-contained, no dependency
// on kymee-cart-drawer.js. Triggered by .card-stone-swatch (card-product.liquid).
(function () {
    "use strict";

    function runInjectedScripts(root) {
        root.querySelectorAll("script").forEach((oldScript) => {
            const newScript = document.createElement("script");
            for (const attr of oldScript.attributes) newScript.setAttribute(attr.name, attr.value);
            newScript.textContent = oldScript.textContent;
            oldScript.replaceWith(newScript);
        });
    }

    function initScrollIndicators(root) {
        (root || document).querySelectorAll(".scroll1").forEach((el) => {
            if (el.dataset.kyScrollInit) return;
            el.dataset.kyScrollInit = "1";

            const indicator = document.createElement("div");
            indicator.className = "kymee-scroll-indicator";
            const thumb = document.createElement("div");
            thumb.className = "kymee-scroll-thumb";
            indicator.appendChild(thumb);
            el.insertAdjacentElement("afterend", indicator);

            function update() {
                const scrollable = el.scrollWidth - el.clientWidth;
                if (scrollable < 2) { indicator.hidden = true; return; }
                indicator.hidden = false;

                const trackW = indicator.clientWidth || el.clientWidth;
                const thumbW = Math.max(24, (el.clientWidth / el.scrollWidth) * trackW);
                const maxLeft = trackW - thumbW;
                const left = (el.scrollLeft / scrollable) * maxLeft;

                thumb.style.width = thumbW + "px";
                thumb.style.transform = "translateX(" + left + "px)";
            }

            el.addEventListener("scroll", update, { passive: true });
            new ResizeObserver(update).observe(el);
            update();
        });
    }

    function getOrCreateModal() {
        if (!document.getElementById("kymee-cpqv-backdrop")) {
            const bd = document.createElement("div");
            bd.id = "kymee-cpqv-backdrop";
            bd.className = "kymee-cpqv-backdrop";
            bd.addEventListener("click", closeModal);
            document.body.appendChild(bd);
        }

        let modal = document.getElementById("kymee-cpqv-modal");
        if (!modal) {
            modal = document.createElement("div");
            modal.id = "kymee-cpqv-modal";
            modal.className = "kymee-cpqv-modal";
            modal.setAttribute("hidden", "");
            modal.innerHTML = `
                <div class="kymee-cpqv-modal__box">
                    <button class="kymee-cpqv-modal__close" type="button" aria-label="Close">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 4L4 12M4 4l8 8" stroke="#5B5B5B" stroke-width="1.5" stroke-linecap="round"/></svg>
                    </button>
                    <div class="kymee-cpqv-modal__body"></div>
                </div>`;
            document.body.appendChild(modal);
            modal.querySelector(".kymee-cpqv-modal__close").addEventListener("click", closeModal);
            // .kymee-cpqv-modal covers the full viewport (pointer-events:auto
            // when open) and sits above #kymee-cpqv-backdrop, so clicks in the
            // empty area around the box never reach the backdrop's own
            // listener — close here whenever the click lands on the modal
            // background itself, not one of its descendants (the box).
            modal.addEventListener("click", (e) => {
                if (e.target === modal) closeModal();
            });
        }
        return modal;
    }

    function openModalShell(modal) {
        modal.removeAttribute("hidden");
        const bd = document.getElementById("kymee-cpqv-backdrop");
        if (bd) bd.classList.add("is-open");
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        // same idea as the header disappearing while a scroll-locked overlay
        // is open — hide the desktop filter bar + subcategory nav too, since
        // they otherwise stay floating above the dimmed backdrop
        document.body.classList.add("kymee-cpqv-modal-open");
        // next frame so the transform transition actually animates in
        requestAnimationFrame(() => requestAnimationFrame(() => modal.classList.add("is-open")));
    }

    function closeModal() {
        const modal = document.getElementById("kymee-cpqv-modal");
        const bd = document.getElementById("kymee-cpqv-backdrop");
        if (modal) modal.classList.remove("is-open");
        if (bd) bd.classList.remove("is-open");
        document.body.classList.remove("kymee-cpqv-modal-open");
        setTimeout(() => {
            if (modal) modal.setAttribute("hidden", "");
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
        }, 360);
    }

    async function openCardProductQuickView(handle, preselectValue) {
        const modal = getOrCreateModal();
        const body = modal.querySelector(".kymee-cpqv-modal__body");
        body.innerHTML = `<div class="kymee-vedit__loading"><span class="kymee-spinner kymee-spinner--lg"></span></div>`;
        openModalShell(modal);

        try {
            const res = await fetch(`/products/${handle}?sections=kymee-card-product-quick-view`);
            const data = await res.json();
            const html = data["kymee-card-product-quick-view"];
            if (!html) throw new Error("no kymee-card-product-quick-view section");
            body.innerHTML = html;
            runInjectedScripts(body);
            initHandlers(body, preselectValue);
        } catch (e) {
            console.warn("[Kymee CPQV] failed:", e.message);
            closeModal();
        }
    }

    function initHandlers(body, preselectValue) {
        initScrollIndicators(body);

        // This button is injected after page load, so wishlist.js's own
        // DOMContentLoaded/wishlist:updated sync never sees it — match its
        // .active state against localStorage right here.
        try {
            const list = JSON.parse(localStorage.getItem("wishlist") || "[]");
            body.querySelectorAll(".wishlist_button").forEach((btn) => {
                btn.classList.toggle(
                    "active",
                    list.some((i) => i.productVariant === btn.dataset.productVariantId)
                );
            });
        } catch {}

        // applyValue() below fully rebuilds the grid/swiper markup from
        // JSON media data every time a swatch is picked (and once on open,
        // since a value is auto-selected) — that would wipe the Liquid-
        // rendered wishlist button along with it, so its HTML is captured
        // here (with the correct .active state above already applied) and
        // re-inserted into the freshly built first image/slide each time.
        const wishlistBtnHTML = body.querySelector(".wishlist_button")?.outerHTML || "";

        let variants = [], media = [];
        try {
            const dataEl = body.querySelector("#kymee-cpqv-data");
            if (dataEl) {
                const parsed = JSON.parse(dataEl.textContent);
                variants = parsed.variants || [];
                media = parsed.media || [];
            }
        } catch {}

        // Same rule the product page uses (product-media-gallery.liquid +
        // assets/variant_change.js): an image whose alt text matches a real
        // variant option value only shows for that value — everything else
        // (mood/lifestyle shots with no matching alt) always stays visible.
        const allValues = new Set();
        variants.forEach(v => {
            [v.option1, v.option2, v.option3].forEach(o => {
                if (o) allValues.add(String(o).trim().toLowerCase());
            });
        });

        const fmt = (amount) => {
            if (window.Shopify?.formatMoney) {
                return window.Shopify.formatMoney(
                    amount,
                    window.money_format || window.Shopify.money_format || "${{amount}}"
                );
            }
            return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
                style: "currency",
                currency: window.Shopify?.currency?.active || "USD",
                maximumFractionDigits: 0,
            }).format((amount || 0) / 100);
        };
        const grid = body.querySelector("#kymee-cpqv-grid");
        const swiperEl = body.querySelector("#kymee-cpqv-swiper");
        const priceRow = body.querySelector("#kymee-cpqv-price");
        const selLabel = body.querySelector("#kymee-cpqv-selected-value");
        const viewDetailsBtn = body.querySelector("#kymee-cpqv-view-details");

        // Shared so it can run both from applyValue() (Stone Colour products)
        // and standalone for products with no Stone Colour option at all —
        // applyValue() never used to run for those, which meant the swiper
        // was never initialized for the vast majority of products.
        function initSwiperInstance() {
            if (!swiperEl) return;
            // Deferred a frame: Swiper reads the container's actual layout
            // width at init time, and right after open the popup's slide-up/
            // scale-in transition may not have settled yet — measuring
            // mid-transition was producing a wrong (sometimes zero) width
            // and a broken swiper.
            requestAnimationFrame(() => {
                if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
                swiperEl.classList.remove("swiper-initialized");
                if (window.globalSwiperManager) window.globalSwiperManager.initSwiper(swiperEl);
            });
        }

        let lastAppliedKey = null;

        const applyValue = (value) => {
            const key = String(value || "").trim().toLowerCase();
            // skip redundant destroy+rebuild cycles for the swatch that's
            // already applied — repeated calls were the main source of the
            // swiper feeling janky / occasionally failing to reinit
            if (key === lastAppliedKey) return;
            lastAppliedKey = key;

            let visibleMedia = media.filter(m => {
                const a = String(m.alt || "").trim().toLowerCase();
                if (!a || !allValues.has(a)) return true;
                return a === key;
            });
            // Some products tag every image per colour with no generic/
            // untagged fallback shot — if the selected colour happens to
            // have no matching image, that filter can come back empty.
            // Falling back to showing everything (rather than skipping the
            // whole rebuild) is what keeps the swiper from ending up
            // un-initialized and non-functional for that product.
            if (!visibleMedia.length) visibleMedia = media;

            if (grid) {
                grid.innerHTML = visibleMedia.map(m =>
                    `<img class="kymee-cpqv__grid-img" src="${m.src}" alt="" width="500" height="500" loading="lazy">`
                ).join("");
                grid.insertAdjacentHTML("afterbegin", wishlistBtnHTML);
            }
            if (swiperEl) {
                const wrapperEl = swiperEl.querySelector(".swiper-wrapper");
                if (wrapperEl) {
                    wrapperEl.innerHTML = visibleMedia.map((m, i) =>
                        `<div class="swiper-slide"><img src="${m.src}" alt="" width="500" height="500" loading="lazy">${i === 0 ? wishlistBtnHTML : ""}</div>`
                    ).join("");
                }
                initSwiperInstance();
            }

            const match = variants.find(v =>
                [v.option1, v.option2, v.option3].some(o => o && String(o).trim().toLowerCase() === key));
            if (match) {
                // Mirrors updatePriceUI() in assets/variant_change.js — the price
                // row here is rendered by the same snippets/price.liquid, so it
                // needs the same .price/.price__sale/.price__regular updates.
                const container = priceRow ? priceRow.querySelector(".price") : null;
                if (container) {
                    const price = Number(match.price || 0);
                    const compareAtPrice = Number(match.compare_at_price || 0);

                    const salePriceEl =
                        container.querySelector(".price__sale .price-item--sale.price-item--last") ||
                        container.querySelector(".price__sale .price-item--sale");
                    const comparePriceEl =
                        container.querySelector(".price__sale .price-item--regular") ||
                        container.querySelector(".price__regular .price-item--regular") ||
                        container.querySelector(".price__regular .price-item");
                    const regularOnlyPriceEl =
                        container.querySelector(".price__regular .price-item") ||
                        container.querySelector(".price-item--regular");

                    if (compareAtPrice > price) {
                        container.classList.add("price--on-sale");
                        if (salePriceEl) salePriceEl.textContent = fmt(price);
                        if (comparePriceEl) {
                            comparePriceEl.textContent = fmt(compareAtPrice);
                            comparePriceEl.classList.remove("hidden");
                        }
                    } else {
                        container.classList.remove("price--on-sale");
                        if (regularOnlyPriceEl) regularOnlyPriceEl.textContent = fmt(price);
                        if (salePriceEl) salePriceEl.textContent = fmt(price);
                        if (comparePriceEl) {
                            comparePriceEl.textContent = "";
                            comparePriceEl.classList.add("hidden");
                        }
                    }
                }
                if (viewDetailsBtn) viewDetailsBtn.href = `${viewDetailsBtn.href.split("?")[0]}?variant=${match.id}`;
            }
            if (selLabel) selLabel.textContent = value;
        };

        if (preselectValue) {
            body.querySelectorAll('input[type="radio"]').forEach(r => {
                if (r.value === preselectValue) r.checked = true;
            });
        }

        body.querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.addEventListener("change", () => { if (radio.checked) applyValue(radio.value); });
        });

        // Stone Colour has multiple values, so product-variant-options.liquid
        // never auto-checks one on its own (only single-value options do) —
        // fall back to the first value so the popup opens already matching
        // the first/default variant, same as the product page does.
        let activeRadio = body.querySelector('input[type="radio"]:checked');
        if (!activeRadio) {
            activeRadio = body.querySelector('input[type="radio"]');
            if (activeRadio) activeRadio.checked = true;
        }
        if (activeRadio) {
            applyValue(activeRadio.value);
        } else {
            // No Stone Colour option on this product at all, so applyValue()
            // (the only place that was initializing the swiper) never runs —
            // that's why the swiper only ever worked for Stone Colour
            // products. Init it here directly on the as-rendered slides.
            initSwiperInstance();
        }
    }

    /* Clicking a card that has a Stone Colour option opens the quick view
       instead of navigating straight to the product page; cards without
       one keep the normal <a href> redirect untouched. */
    document.addEventListener("click", (e) => {
        const link = e.target.closest("a");
        if (!link) return;
        const wrap = link.closest("[data-stone-colour-handle]");
        if (!wrap) return;
        e.preventDefault();
        e.stopPropagation();
        openCardProductQuickView(wrap.dataset.stoneColourHandle);
    });
})();
